import styled from '@emotion/styled';
import { IconSquareButton } from '@cencosud-ds/bigbang/antiguo';

export const IconSquareButtonStyled = styled(IconSquareButton)`
  margin: 3px 3px 0em 0px;
  width: 100px;
  & .hc-icon {
    path {
      stroke: rgb(77, 77, 77) !important;
    }
  }
  &:hover .hc-icon {
    path {
      stroke: rgb(255, 255, 255) !important;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 10;
  overflow: auto;
  top: 0px;
  bottom: 0px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const WrapperButtonsAndSubButton = styled.div`
  display: flex;
  height: 100px;
  .sub-button {
    display: none;
  }
  :hover {
    .sub-button {
      display: block;
    }
  }
`;
